import { eventLoader } from '@otto-ec/global-resources/event-loader';
import "../scss/feedback/feedbackForm.scss";
import { registerFeedbackForm } from './feedback/FeedbackForm';

eventLoader.onReady(99, () => {
    registerFeedbackForm();
});
